var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClockBackward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-backward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.335938 7.9987C0.335938 4.31664 3.32157 1.33203 7.00416 1.33203C9.4731 1.33203 11.6278 2.67387 12.7798 4.66482C12.9642 4.9835 12.8554 5.39133 12.5367 5.57573C12.218 5.76013 11.8102 5.65127 11.6258 5.33258C10.7024 3.73672 8.97807 2.66536 7.00416 2.66536C4.05762 2.66536 1.66927 5.05334 1.66927 7.9987C1.66927 10.9441 4.05762 13.332 7.00416 13.332C9.72631 13.332 11.9721 11.2939 12.2983 8.66109L11.8307 9.1286C11.5703 9.38892 11.1482 9.38886 10.8879 9.12848C10.6275 8.8681 10.6276 8.44599 10.888 8.18567L12.3884 6.68567C12.6487 6.4254 13.0707 6.4254 13.3311 6.68567L14.8314 8.18567C15.0918 8.44599 15.0919 8.8681 14.8316 9.12848C14.5713 9.38886 14.1491 9.38892 13.8888 9.1286L13.6176 8.85748C13.1961 12.1339 10.3957 14.6654 7.00416 14.6654C3.32157 14.6654 0.335938 11.6808 0.335938 7.9987ZM7.0026 5.08203C7.37079 5.08203 7.66927 5.38051 7.66927 5.7487V8.40428L9.46342 9.00233C9.81272 9.11876 10.0015 9.49631 9.88506 9.8456C9.76863 10.1949 9.39108 10.3837 9.04179 10.2672L6.79179 9.51724C6.51956 9.4265 6.33594 9.17174 6.33594 8.88479V5.7487C6.33594 5.38051 6.63441 5.08203 7.0026 5.08203Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockBackward);
export default __webpack_public_path__ + "static/media/ic-clock-backward.5a4e8c2db68c394dd37d4efc550508e3.svg";
export { ForwardRef as ReactComponent };